<template>
  <div class="home">
    <img :src="homeBackground" alt="" mode="widthFix">
    <div class="music-box">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/14/F9/rB4ChWL6Do2AMIn1AAAFj6TyvdU119.png" alt="" v-if="isPlay" @click="play">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/14/F8/rB4ChmL6D42AQHksAAAFCjQ7euo129.png" alt="" v-else @click="play">
    </div>
    <div class="right">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/14/CB/rB4ChWL0vUmAZZ9LAABDQY3dgVo278.png" alt="">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/14/CB/rB4ChWL0vZyAIEGsAABJb8taVE4496.png" alt="" v-if="isLottery">
    </div>
    <div class="button-box">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/15/1D/rB4ChmL9-P6AHlHZAABEH1dMh-Q514.png" alt="" @click="to('/answer')">
    </div>
    
    <div class="text">
      已有118人参与活动 <br/> 您今天还有5次参与机会 
    </div>
    <audio ref="audio" preload="auto" loop id="audio" :src="backgroundMusic"></audio>
  </div>
</template>

<script>
export default {
  props: {
    isLottery: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      homeBackground: 'https://img3.quanyou.com.cn/joy/group1/M00/14/CB/rB4ChWL0ufCARwhpAA1b5TenLOc864.png',
      isMusic: false,
      questionDetail: {},
      backgroundMusic: '',
      oAudio: null,
      isPlay: false,
    }
  },
  computed: {
    query() {
      return this.$route.query
    },
    activityId() {
      return this.$route.query.activityId || ''
    },
    isNewcreateMode() {
      return this.$route.query.creationMode == 'new'
    }
  },
  methods: {
    queryActivityQuestion() {
      this.$api.question.queryActivityQuestion(this.activityId).then(res => {
        if (res.success && res.data) {
          this.questionDetail = res.data
          const { homeBackground,backgroundMusic } = res.data
          this.homeBackground = homeBackground || 'https://img3.quanyou.com.cn/joy/group1/M00/14/CB/rB4ChWL0ufCARwhpAA1b5TenLOc864.png'
          this.backgroundMusic = backgroundMusic
        }
      })
    },

    to(path) {
      // let params = {
      //   ...this.query,
      //   from: 'home',
      // }
      if (this.isNewcreateMode) return
      this.$router.push({path,query:this.query})
    },
    onCancel() {
      this.isMusic = false
    },
    play() {
      if (this.backgroundMusic) {
        this.isPlay = !this.isPlay
        if (this.isPlay) {
          this.getMusic()
        }else {
          this.oAudio.pause()
        }
      }else {
        this.$toast('暂无音乐')
      }
    },
    getMusic() {
      document.addEventListener('touchstart',this.audioAutoPlay,false);
      document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay,false);
      this.oAudio = document.querySelector("#audio");
      this.oAudio.load();
      this.oAudio.play();
    }
  },
  mounted() {
    this.queryActivityQuestion()
  },
 
}
</script>

<style lang="stylus" scoped>
  .home {
    position: relative
    height 100%
    overflow hidden
    font-size 0
    img {
      width 100%
      height auto
    }
    .music-box {
      top: 32px;
      position: absolute;
      right: 12px;
      img {
        width 28px;
        height: 28px;
      }
    }
    .right {
      position: absolute;
      top: 124px;
      right: 10px;
      img {
        display: block;
        width: 40px;
        height: 40px;
        margin-bottom: 10px;
      }
    }
    .button-box {
        position:absolute;
        bottom: 62px;
        left:50%;
        margin-left: -77.5px;
      img {
        width: 155px;
        height: 62px;
        margin-bottom: 10px;
      }
    }
    .text {
      position: absolute;
      bottom: 33px;
      left: 50%;
      margin-left: -57px;
      width: 130px;
      text-align: center;
      font-size: 10px;
      font-weight: 500;
      color: #A4D6A6;
    }
  }
 
</style>